(function () {
  'use strict';

  function initWizard(root) {
    const form = root.closest('form');
    const steps = Array.from(root.querySelectorAll('[data-kit-quote-step]'));
    const backBtn = root.querySelector('[data-kit-quote-back]');
    const nextBtn = root.querySelector('[data-kit-quote-next]');
    const submitBtn = root.querySelector('[data-kit-quote-submit]');
    const progressFill = root.querySelector('[data-kit-quote-progress]');
    const piecesField = root.querySelector('[data-kit-quote-pieces-field]');
    const pieceCheckboxes = root.querySelectorAll('[data-kit-quote-piece-checkbox]');

    if (!steps.length || !form) return;

    let current = 0;

    function render() {
      steps.forEach((step, i) => step.classList.toggle('is-active', i === current));
      backBtn.hidden = current === 0;
      const isLast = current === steps.length - 1;
      nextBtn.hidden = isLast;
      submitBtn.hidden = !isLast;
      const pct = ((current + 1) / steps.length) * 100;
      progressFill.style.width = pct + '%';
    }

    function stepIsValid(step) {
      const fields = step.querySelectorAll('input, textarea, select');
      let valid = true;
      fields.forEach((field) => {
        if (!field.checkValidity()) {
          field.reportValidity();
          valid = false;
        }
      });
      return valid;
    }

    function goNext() {
      if (!stepIsValid(steps[current])) return;
      if (current < steps.length - 1) {
        current += 1;
        render();
        steps[current].scrollIntoView({ block: 'nearest' });
      }
    }

    function goBack() {
      if (current > 0) {
        current -= 1;
        render();
        steps[current].scrollIntoView({ block: 'nearest' });
      }
    }

    nextBtn.addEventListener('click', goNext);
    backBtn.addEventListener('click', goBack);

    // Pressing Enter in a field triggers native implicit form submission even
    // while the submit button is hidden (it's still a valid target per spec).
    // Intercept that here: treat Enter as "advance" on every step but the last.
    form.addEventListener('submit', (event) => {
      if (current !== steps.length - 1) {
        event.preventDefault();
        goNext();
      }
    });

    if (piecesField && pieceCheckboxes.length) {
      const syncPieces = () => {
        const selected = Array.from(pieceCheckboxes)
          .filter((cb) => cb.checked)
          .map((cb) => cb.getAttribute('data-label'));
        piecesField.value = selected.join(', ');
      };
      pieceCheckboxes.forEach((cb) => cb.addEventListener('change', syncPieces));
      syncPieces();
    }

    render();
  }

  document.querySelectorAll('[data-kit-quote-root]').forEach(initWizard);
})();
